import SavedAddressesItem from './SavedAddressesItem';

export default SavedAddressesItem;
